import { createAction, props } from '@ngrx/store';

export const SET_FULLSCREEN_VISIBILITY = '[fullscreen loader] Set visibility state';

export const setVisibility = createAction(
  SET_FULLSCREEN_VISIBILITY,
  props<{ isVisible: boolean; loaderType?: string; contentfulMessageKey?: string; contentfulBody?: string }>()
);
